var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inbox"},[_vm._v(" Browser"),_c('hr'),_vm._v(" "+_vm._s(_vm.url)+" "),_c('br'),_vm._v(" FOLDER URL : "+_vm._s(_vm.folder.url)+" "),_c('hr'),_c('SolidEditor'),_c('EditorJs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }